import { normalizeCustomerID } from "@/classes/customerID";
import { Capacitor } from "@capacitor/core";

// This roster contains display identities only, never authentication credentials.
// Native capacitor:// origins cannot persist document cookies. Keep their roster
// in localStorage so PIN sign-in survives logout and cold launch on shared devices.
// Both storage paths remain tenant-scoped.
export const KIOSK_USERS_COOKIE = "kiosk_users";

function readRoster(cookies) {
    if (Capacitor.isNativePlatform()) {
        try {
            const value = JSON.parse(localStorage.getItem(KIOSK_USERS_COOKIE));
            return value && typeof value === "object" ? value : null;
        } catch {
            return null;
        }
    }
    const value = cookies.get(KIOSK_USERS_COOKIE);
    if (!value || typeof value !== "object") return null;
    return value;
}

export function getKioskUsers(cookies, customerID) {
    const stored = readRoster(cookies);
    if (!stored) return [];

    const tenant = normalizeCustomerID(customerID);
    const storedTenant = normalizeCustomerID(stored.tenant);
    // A cookie written before tenant scoping has no tenant; keep it for the
    // domain the device is on now and stamp it on the next write.
    if (storedTenant && storedTenant !== tenant) {
        removeKioskUsers(cookies);
        return [];
    }

    return Array.isArray(stored.kiosk_users) ? stored.kiosk_users : [];
}

export function setKioskUsers(cookies, customerID, kioskUsers) {
    const roster = {
        tenant: normalizeCustomerID(customerID),
        kiosk_users: kioskUsers
    };
    if (Capacitor.isNativePlatform()) {
        try {
            localStorage.setItem(KIOSK_USERS_COOKIE, JSON.stringify(roster));
        } catch {
            // Password sign-in remains available when roster persistence fails.
        }
        return;
    }
    cookies.set(KIOSK_USERS_COOKIE, roster);
}

export function removeKioskUsers(cookies) {
    if (Capacitor.isNativePlatform()) {
        try {
            localStorage.removeItem(KIOSK_USERS_COOKIE);
        } catch {
            // A storage failure must not prevent leaving the customer domain.
        }
    }
    cookies.remove(KIOSK_USERS_COOKIE);
}
